<template>
  <div id="ht-wrap">

    <div class="camera-wrap">
      <div class="videoDetails-warp" @mousedown="moveCamera">
        <!-- 视频窗口 -->
        <video id="myPlayer" :src=videoPath controls playsInline webkit-playsinline autoplay>
        </video>
        <span class="iconfont" @click="closeVideo">&#xe71b;</span>
      </div>
    </div>
    <div class="dialog-wrap">
      <el-dialog title="'您正在进行的是开门操作'" :visible.sync="doorStatus" @close="clearForm" >
        <el-form status-icon ref="door_form">
          <div class="clear box_body">
            <el-form-item label="密  码：" prop="dooPsd">
              <el-input type="password" v-model="doorForm.door_psd" auto-complete="off" class="input_box"></el-input>
            </el-form-item>
            <div>
              <el-form-item label="开门时间：" prop="door_interval">
                <el-input type="text" v-model="doorForm.door_interval" class="input_box"></el-input>
                <span>秒</span>
              </el-form-item>
            </div>

          </div>
          <div class="box_footer clear">
            <el-button type="text" size="small" @click="formSubmit" class="right">确定</el-button>
            <el-button type="text" size="small" @click="clearForm" class="right">取消</el-button>
          </div>
        </el-form>
      </el-dialog>
    </div>

  </div>
</template>

<script>
  import * as EZUIKit from "../../assets/js/external/ezuikit";
  export default {
    name: "eleDistributionRoom1",
    data(){
      return{
        dataModel: null,
        graphView: null,
        g3d: null,
        dm: null,
        statusArr: [],      //分合闸灯
        routeData: null,
        videoData: null,
        videoPath: '',

        // 报警信息
        // alarmData: {
        //   "data": {
        //     "TG232:a1_b1": {
        //       "id": "1",
        //       "alarmLevel": "1",
        //       "alarmCategoryName": "电表",
        //       "alarmResultDefinition": "过压报警(超过或达到高限)",
        //       "deviceAssetNumber": "010100001",
        //       "divisionName": "北自园区",
        //       "alarmDescription": "测试报警位置",
        //       "createdAt": "1970-01-01 00:00:00",
        //       "alarmValue": "102.00",
        //       "alarmThreshold": "100",
        //       "isDeal": "0",
        //       "nickName": null,
        //       "confirm_time": null,
        //       "alarmImageUri": null
        //     }
        //   },
        //   "totalNumber": 1
        // },
        alarmData:'',

        routePanel: null,    //回路面板
        alarmPanel: null,     //报警面板

        alarmStatus: true,

        wallStatus: false,
        panelStatus: true,
        timer: null,
        tokenArr: {},
        doorStatus: false,
        doorForm: {}
      }
    },
    beforeCreate() {
      window.htUrl('eleDistributionRoom1');
    },
    mounted() {
      this.initModels();
      this.getData();
      this.interval();
      this.getEnvData();
    },
    beforeDestroy() {
      clearInterval(this.timer);
      this.timer = null;
    },
    watch: {
      videoPath(val){
        this.$nextTick(function(){
          new EZUIKit.EZUIPlayer('myPlayer');
        })
      },
    },
    methods:{
      initModels(){
        let _this = this;
        this.dataModel = new ht.DataModel();  // 数据容器

        this.g3d = new ht.graph3d.Graph3dView();
        this.g3d.addToDOM(document.getElementById('ht-wrap'));
        this.g3d.deserialize('scenes/room.json', function (json, dm, g3d, datas) {
          g3d.setEye(-158, 3095, 4937);
          g3d.setCenter(-154, 2153, 1602);//目标
          g3d.setFar(1000000);
        });
        this.g3d.addInteractorListener(e => {
          _this.getModel(e);
        })

        this.graphView = new ht.graph.GraphView(this.dataModel); // 2d 绑定数据模型
        this.dm = this.graphView.dm();
        this.graphView.deserialize('displays/display.json', function (json, dm, g3d, datas) {
          _this.routePanel = dm.getDataByTag('routePanel');
          _this.alarmPanel = dm.getDataByTag('alarmPanelNote');
          _this.alarmMessage()
          _this.getEnvData()
        });
        this.graphView.addToDOM(this.g3d.getView());
        this.graphView.mi(this.getControlBtn);


        //设置交互限制
        let mapInteractor = new ht.graph3d.MapInteractor(this.g3d);
        this.g3d.setInteractors([mapInteractor]); //禁止3d图形下移翻转,拖动，平移
        // 禁止所有缩放
        this.graphView.setZoomable(false);
        // 左键可拖拽编辑图元，右键可改变视角方向，采用这样的方式一般会结合键盘w|s|a|d按键进行漫游操作
        this.g3d.setMouseRoamable(false);

        ht.Default.graph3dViewMaxPhi = Math.PI/2; //最大角度
        ht.Default.graph3dViewMinPhi = 0 //最小角度
      },
      getData(){
        this.$get('eledistributionroom1/index',[ '01010002', 'eleDistributionRoom1', 999, 1, '080100012'])
        .then((res) =>{
          // this.routeData = res.realTimeData;
          let data = res.realTimeData;
          let tempRouteData = {};
          for(let i in data){
            let tag = i.split(':')[1];
            let obj = data[i].data;
            obj.name = data[i].description;
            obj.pos = false;
            tempRouteData[tag] = obj;
            let di = data[i].data.di;
            if(di == 1){    //分闸
              this.g3d.dm().getDataByTag(tag+'_alarm1').s('shape3d.blend', 'rgb(255,255,255)');
              this.g3d.dm().getDataByTag(tag+'_normal1').s('shape3d.blend', 'rgb(6,74,4)');
            }else{
              this.g3d.dm().getDataByTag(tag+'_alarm1').s('shape3d.blend', 'rgb(145,51,51)');
              this.g3d.dm().getDataByTag(tag+'_normal1').s('shape3d.blend', 'rgb(255,255,255)');
            }
          }
          this.routeData = tempRouteData;
          this.videoData = res.videoMessage[0];
          this.alarmData = res.alarmMessage;
          //面板按钮
          // if(this.panelStatus){
          //   this.dm.getDataByTag('panelText').s("text", "隐藏面板");
          // }else{
          //   this.dm.getDataByTag('panelText').s("text", "显示面板");
          // }
        })
      },
      getControlBtn(e){
        const {kind, data} = e; // 事件类型，
        const click_buttons = ["lowCabinet", "water", "smog", "door", "wall", "panel", "reset"];
        let pxArr = [563 ,642.18, 719.9, 801.6, 891.8, 971.0, 1055.6];
        let icon = this.graphView.dm().getDataByTag("buttonHoverIcon");
        if (kind === "clickData") {
          let tag = data.getTag();

          let index = click_buttons.indexOf(tag);
          // 添加图标下面的蓝色方块
          if (index > -1) {
            icon.setX(pxArr[index]);
          }

          if( tag == 'lowCabinet'){
            this.flyToView(this.g3d , [-158, 3095, 4937], [-154, 2153, 1602]);
          }else if(tag == 'water'){
            this.flyToView(this.g3d , [3224, 603, 1593], [4174, 154, 2234]);
          }else if(tag == 'smog'){
            this.flyToView(this.g3d , [7, 2490, 817], [0, 2465, 300]);
          }else if(tag == 'door'){
            this.g3d.dm().getDataByTag('doorArr').s('3d.visible', true);
            this.doorStatus = true;
          }else if(tag == 'wall'){
            if(this.wallStatus){
              this.g3d.dm().getDataByTag('wallArr').s('3d.visible', false);
              this.g3d.dm().getDataByTag('doorArr').s('3d.visible', false);
              this.dm.getDataByTag('wallText').s("text", "显示墙壁");
            }else{
              this.g3d.dm().getDataByTag('wallArr').s('3d.visible', true);
              this.g3d.dm().getDataByTag('doorArr').s('3d.visible', true);
              this.dm.getDataByTag('wallText').s("text", "隐藏墙壁");
            }
            this.wallStatus = !this.wallStatus;
          }else if(tag == 'panel'){
            let panelStatus = this.dm.getDataByTag('panelText').s('text') == '隐藏面板';
            if(!panelStatus){
              if(this.alarmData.totalNumber != 0){
                this.closePanel('alarm');
                this.dm.getDataByTag('carousel2').s("2d.visible", true)
              }
              this.closePanel('env');
              this.dm.getDataByTag('panelText').s("text", "隐藏面板");
            }else{
              this.closePanel('alarm', true)
              this.dm.getDataByTag('carousel2').s("2d.visible", false);
              this.closePanel('env', true);
              this.dm.getDataByTag('panelText').s("text", "显示面板");
            }
          }else if(tag == 'reset'){
            this.flyToView(this.g3d , [-158, 3095, 4937], [-154, 2153, 1602]);
          }else if(tag == 'envCloseBtn'){
            this.closePanel('env', true);
            // this.panelStatus = false;
          }else if(tag == 'alarmCloseBtn'){
            this.closePanel('alarm', true);
            this.dm.getDataByTag('carousel2').s("2d.visible", false)
            // this.alarmStatus = false;
          }else if(tag == 'returnBtn'){
            this.$router.back(-1);
          }
        }else if (kind === "onEnter") {
          let tag = data.getTag();

          // 鼠标移入变小手
          if (click_buttons.indexOf(tag) > -1) {
            this.graphView.getView().style.cursor = "pointer";
          }
        }else if (kind === "onLeave") {
          let tag = data.getTag();
          if (click_buttons.indexOf(tag) > -1) {
            this.graphView.getView().style.cursor = "default";
          }
        }
      },

      // 报警信息
      alarmMessage(){
        let alarmPanel = this.dm.getDataByTag('alarmPanel')
        let carousel = this.dm.getDataByTag('carousel2')

        if (this.alarmData != ''){
          alarmPanel.s('2d.visible', true)
          carousel.s('2d.visible', true)

          let i = 1;
          carousel.a('ht.dataSource',[
            {
              "alarmGenre": this.alarmData.data["TG232:a1_b1"].alarmResultDefinition,
              "alarmParcel": this.alarmData.data["TG232:a1_b1"].divisionName,
              "alarmDescribe": this.alarmData.data["TG232:a1_b1"].alarmDescription,
              "alarmTime": this.alarmData.data["TG232:a1_b1"].createdAt,
              "alarmValue": this.alarmData.data["TG232:a1_b1"].alarmValue,
              "alarmRank": this.alarmData.data["TG232:a1_b1"].alarmLevel,
            },
            {
              "alarmGenre": this.alarmData.data["TG232:a1_b1"].alarmResultDefinition,
              "alarmParcel": this.alarmData.data["TG232:a1_b1"].divisionName,
              "alarmDescribe": this.alarmData.data["TG232:a1_b1"].alarmDescription,
              "alarmTime": this.alarmData.data["TG232:a1_b1"].createdAt,
              "alarmValue": this.alarmData.data["TG232:a1_b1"].alarmValue,
              "alarmRank": this.alarmData.data["TG232:a1_b1"].alarmLevel,
            }
          ])
          let timer = setInterval(function () {
            // carousel.a('ht.offset', i)
            // i+=0.5;
            ht.Default.startAnim({
              duration: 1000, // 动画周期毫秒数，默认采用`ht.Default.animDuration`
              action: function(v, t){
                carousel.a('ht.offset', i+355*v)
              }
            });
          },3000)
          this.graphView.addInteractorListener(e => {
            if(e.data && e.data._tag === 'carousel2') {
              if (e.kind === "onEnter") {
                let node = e.data;
                if (node._tag === 'carousel2'){
                  clearInterval(timer);
                }
              }else if(e.kind === "onLeave") {
                let node = e.data;
                if (node._tag === 'carousel2'){
                  clearInterval(timer);
                  timer = setInterval(function () {
                    // carousel.a('ht.offset', i)
                    // i+=0.5;
                    ht.Default.startAnim({
                      duration: 1000, // 动画周期毫秒数，默认采用`ht.Default.animDuration`
                      action: function(v, t){
                        carousel.a('ht.offset', i+355*v)
                      }
                    });
                  },3000)
                }
              } else if(e.kind === "onClick") {
                this.$router.push('/alarmManagement');
              }
            }
          })
        }else {
          alarmPanel.s('2d.visible', false)
          this.closePanel('alarm', true)
          carousel.s('2d.visible', false)
        }
      },

      getModel(e){
        this.routePanel = this.g3d.dm().getDataByTag('routePanel');
        if (e.kind === "clickData") {
          let node = e.data;
          let tag = node.getTag();
          if(tag){
            if(tag.indexOf('b1_') != -1){
              if(this.tokenArr[tag] === undefined){
                this.tokenArr[tag] = false;
              }
              this.routePanel.a("routeName", this.routeData[tag].name);
              this.routePanel.a("ia", this.routeData[tag].ia);
              this.routePanel.a("ib", this.routeData[tag].ib);
              this.routePanel.a("ic", this.routeData[tag].ic);
              this.routePanel.a("uab", this.routeData[tag].uab);
              this.routePanel.a("ubc", this.routeData[tag].ubc);
              this.routePanel.a("uca", this.routeData[tag].uca);
              this.g3d.dm().getDataByTag('routePanelNode').s('3d.visible', true);
              let pos = node.p3();
              this.routePanel.p3(pos[0], 2300 , 80);
              let routeBeforePos = this.g3d.dm().getDataByTag(tag).p3();
              if(this.tokenArr[tag]){
                this.g3d.dm().getDataByTag(tag).p3(routeBeforePos[0], routeBeforePos[1], routeBeforePos[2] - 350);
              }else{
                this.g3d.dm().getDataByTag(tag).p3(routeBeforePos[0], routeBeforePos[1], routeBeforePos[2] + 350);
              }
              this.tokenArr[tag] = !this.tokenArr[tag];
            }else if(tag == 'camera'){
              this.videoPath = this.videoData.m3u8Address;
              document.querySelector('.camera-wrap').style.cssText = 'display:block';
            }
          }

        }
      },
      moveCamera(e){
        let odiv = e.target;// 获取目标元素
        let close_btn = document.querySelector('.videoDetails-warp span');
        //计算出鼠标相对点击元素的位置,e.clientX获取的是鼠标的位置，OffsetLeft是元素相对于外层元素的位置
        let x = e.clientX - odiv.offsetLeft;
        let y = e.clientY - odiv.offsetTop;
        document.onmousemove = (e) => {
          // 获取拖拽元素的位置
          let left = e.clientX - x;
          let top = e.clientY - y;
          this.positionX = left;
          this.positionY = top;
          odiv.style.left = left + "px";
          odiv.style.top = top + "px";
        }
        // 为了防止 火狐浏览器 拖拽阴影问题
        document.onmouseup = (e) => {
          document.onmousemove = null;
          document.onmouseup = null
        }
      },
      closeVideo(){
        this.videoPath = '';
        document.querySelector('.camera-wrap').style.cssText = 'display:none';
      },
      flyToView(t, e, n) {
        let _this = this;
        let i = ht.Default.clone(t.getEye()),
          r = ht.Default.clone(t.getCenter()),
          o = e[0] - i[0],
          s = e[1] - i[1],
          d = e[2] - i[2],
          u = n[0] - r[0],
          l = n[1] - r[1],
          h = n[2] - r[2];
        ht.Default.startAnim({
          duration: 5000,
          easing: function (e) {
            return e
          },
          action: function (e) {
            t.setEye([i[0] + o * e, i[1] + s * e, i[2] + d * e]),
              t.setCenter([r[0] + u * e, r[1] + l * e, r[2] + h * e])
          }
        });
      },
      closePanel(name, action){
        if(action){
          this.dm.getDataByTag(name + 'Panel').s('2d.visible', false);
          this.dm.getDataByTag(name + 'CloseBtn').s('2d.visible', false);
        }else{
          this.dm.getDataByTag(name + 'Panel').s('2d.visible', true);
          this.dm.getDataByTag(name + 'CloseBtn').s('2d.visible', true);
        }
      },
      interval(){
        let _this = this;
        this.timer = setInterval(function(){
          _this.getData();
          _this.getEnvData();
        }, 5000)
      },
      clearForm(){
        this.doorForm = {};
        this.doorStatus = false;
      },
      formSubmit() {
        if (!this.doorForm.doorPsd) {
          this.$message.error('请输入密码！');
          return false;
        }
        if (!this.door_form.door_interval) {
          this.$message.error('请输入开门时间！');
          return false;
        }
      },
      getEnvData(){
        this.$get('eledistributionroom1/gettransformerroomtemperaturehumidity',[1, '01010002'])
        .then((res) =>{
          let envPanel = this.dm.getDataByTag("envPanel");
          envPanel.a('humidity', res.humidity);
          envPanel.a('temp', res.temperature);
          let waterSeepage = this.g3d.dm().getDataByTag('waterSeepage');
          let smoke = this.g3d.dm().getDataByTag('smoke');
          if(res.immersion == 1){
            waterSeepage.s('shape3d.blend', 'rgb(214,54,54)');
          }else{
            waterSeepage.s('shape3d.blend', 'rgb(255,255,255)');
          }
          if(res.smoke == 1){
            smoke.s('shape3d.blend', 'rgb(214,54,54)');
          }else{
            smoke.s('shape3d.blend', 'rgb(255,255,255)');
          }
        })
      }
    }
  }
</script>

<style scoped lang="scss">
#ht-wrap{

}
</style>
